/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import dayjs from 'dayjs'

const BackupRestore = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const [restoreData, setRestoreData] = useState([])
    const dgxRequest = useRef([]);
    const dgxRequestRestore = useRef([]);

    const getDgxData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/dgx', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                console.log(params)
                if (data.find(_ => true)?.result_data?.status.indexOf('success') == -1) {
                    getDgxData(params);
                } else {
                    if(params.hasOwnProperty('restore')){
                        patchRestoreData([{
                            ...params,
                            finish_time: dayjs().format('YYYY-MM-DD HH:mm:ss')
                        }])
                    }else{
                        patchDemoData([{
                            ...params,
                            finish_time: dayjs().format('YYYY-MM-DD HH:mm:ss')
                        }])
                    }
                }
            });
    }
    const getDemoData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/home/backup', {
            params: params,
        })
            .then((response) => {
                let data = response.data.data
                setData(data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data,
                }
            });
    }
    const postDemoData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/home/backup', data)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                    getDemoData()
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchDemoData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/home/backup', data)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success",
                            values:{
                                mode:'backup'
                            }
                        }
                    )
                    getDemoData()
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deletehDemoData = () => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('https://proapi.azurewebsites.net/github/issues',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    const getRestoreData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/home/restore', {
            params: params,
        })
            .then((response) => {
                let data = response.data.data
                setRestoreData(data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data,
                }
            });
    }
    const postRestoreData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/home/restore', data)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                    getRestoreData()
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchRestoreData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/home/restore', data)
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success",
                            values:{
                                mode:'restore'
                            }
                        }
                    )
                    getRestoreData()
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    useEffect(() => {
        dgxRequest.current.forEach((eachItem, eachIndex) => {
            clearTimeout(dgxRequest.current[eachIndex]);
        });
        data.forEach((eachItem, eachIndex) => {
            if (!eachItem.finish_time) {
                dgxRequest.current[eachIndex] = setTimeout(() => {
                    getDgxData({
                        ...eachItem,
                        result_code: eachItem.short_id
                    })
                }, 1000)
            }
        })
    }, [data])
    useEffect(() => {
        dgxRequestRestore.current.forEach((eachItem, eachIndex) => {
            clearTimeout(dgxRequestRestore.current[eachIndex]);
        });
        restoreData.forEach((eachItem, eachIndex) => {
            if (!eachItem.finish_time) {
                dgxRequestRestore.current[eachIndex] = setTimeout(() => {
                    getDgxData({
                        ...eachItem,
                        result_code: eachItem.short_id,
                        restore:true
                    })
                }, 1000)
            }
        })
    }, [restoreData])
    return {
        data,
        restoreData,
        getDemoData,
        postDemoData,
        getRestoreData,
        postRestoreData,
    }
}
export default BackupRestore